module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00303.779b2468.jpg";